import { ActionButton, Content, ContentHeader, DialogRef, FilterMenu, InputSearch, Paging, QueryState, QueryStateContent, Stack, Table, TableBody, TableCell, TableHead, TableRow } from 'src/app/components';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { SalesPromoModel, SalesPromoParticipant, SalesPromoPrizeModel } from 'src/app/modules/campaign/models/SalesPromo.model';
import { FilterMenuSalesPromoPrizeList } from './FilterMenuSalesPromoPrizeList';
import { usePermissions } from 'src/app/hooks/permissions-hook';
import { useSalesPromoTabDetailParticipantDetail } from './SalesPromoTabParticipantDetail.hook';
import SelectGiftByTransactionPopup from './SelectGiftByTransaction/SelectGiftByTransaction';
import { translatePrizeTypeSalesPromo } from '../SalesPromoDetailTabGeneral';

interface SalesPromoTabParticipantPrizeListProps {
  id?: string
  data?: SalesPromoParticipant
  generalInfo?: SalesPromoModel
}

export function SalesPromoTabParticipantPrizeList(props: Readonly<SalesPromoTabParticipantPrizeListProps>) {
  const permission = usePermissions()

  const state = useSalesPromoTabDetailParticipantDetail();
  const prizes = state.participantPrizeList;
  const selectGiftPopup = useRef<DialogRef>(null);

  const [item, setItem] = useState<SalesPromoPrizeModel>()

  const renderItem = (item: SalesPromoPrizeModel, index: number) => {
    return (
      <TableRow key={item.id}>
        <TableCell {...{ index }} />
        <TableCell value={item?.receipt_codes} renderValue={(val: string[]) => {
          return <ul>
            {val.map((item: string, index: number) => (<li key={`item${index}`}>{item}</li>))}
          </ul>
        }} />
        <TableCell value={translatePrizeTypeSalesPromo(item?.prize_type)} />
        <TableCell value={item?.prize_name} />
        <TableCell value={item?.quantity} />
        <TableCell value={item?.status} />
        <TableCell value={item?.is_mission_gift} renderValue={(_) => _ ? 'Yes' : 'No'} />
        <TableCell
          renderValue={(date: string) => {
            return (
              <div>
                {dayjs(date).format('DD/MM/YYYY')}
              </div>
            )
          }}
          className="w-[145px]"
          value={item?.claimed_at}
        />
        <TableCell value={item?.claim_directory?.directory_name} />
        <TableCell action={true}>
          {
            item?.status === 'PENDING'
            && <>{permission.setVisibleByAccess(
              ['manage_campaign_sales_promo.read'],
              // eslint-disable-next-line react/jsx-no-undef
              <ActionButton
                className="mx-auto"
                variant="detail"
                onClick={() => { setItem(item); selectGiftPopup.current?.show() }}
              />
            )}</>}
        </TableCell>
      </TableRow>
    )
  }


  return (
    <>
      <Stack className='pt-6'>
        <Content>
          <ContentHeader title="Prize List" />

          <Stack
            direction="row"
            justify="between"
            items="center"
            className="px-6 py-4"
          >
            <InputSearch />
            <FilterMenu>
              <FilterMenuSalesPromoPrizeList />
            </FilterMenu>
          </Stack>

          <QueryState query={prizes}>
            <div className="px-8">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell index />
                    <TableCell>Receipt ID</TableCell>
                    <TableCell>Prize Type</TableCell>
                    <TableCell>Prize Name</TableCell>
                    <TableCell>Qty Prize</TableCell>
                    <TableCell>Claimed Status</TableCell>
                    <TableCell>Game</TableCell>
                    <TableCell className="w-[145px]">Claimed Date</TableCell>
                    <TableCell>Claimed Location</TableCell>
                    <TableCell action={true} className="w-[100px]" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {prizes.data?.content?.map(renderItem)}
                </TableBody>
              </Table>
              <Paging query={prizes} />
            </div>
            <QueryStateContent title="List Prize is Empty" description=" " />
          </QueryState>
        </Content>
      </Stack>
      <SelectGiftByTransactionPopup dialogRef={selectGiftPopup} params={{ campaign_id: props.generalInfo?.campaign_id, member_id: props.data?.id, member_sales_promo_id: item?.id }}></SelectGiftByTransactionPopup>
    </>
  )
}
